module.exports = __webpack_public_path__ + "static/media/gn.0798100e.svg";